import script from "./HklProductLstComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HklProductLstComponent.vue?vue&type=script&setup=true&lang=js"

import "./HklProductLstComponent.vue?vue&type=style&index=0&id=01fc8292&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01fc8292"]])

export default __exports__